export default "__VITE_ASSET__BPdxwCFH__"